import {
  InternalPhoneNumberAdminViewDto,
  UserAdministrationDto,
} from '@act/shared/data-transfer-objects';
import { phoneFormatter } from '@act/shared/utilities';
import { ColumnConfiguration } from '@act/storybook';

export const PhoneNumbersTableColumns = (
  users: UserAdministrationDto[]
): ColumnConfiguration<InternalPhoneNumberAdminViewDto>[] => [
  {
    id: 'displayName',
    value: (props: InternalPhoneNumberAdminViewDto) =>
      props?.displayName ? `${props?.displayName}` : `${props?.description}`,
    isNumeric: false,
    shouldDisablePadding: false,
    sortable: true,
    title: 'Name',
  },
  {
    id: 'timezone',
    value: (props: InternalPhoneNumberAdminViewDto) => {
      return props.timezone.replace('_', ' ');
    },
    isNumeric: false,
    shouldDisablePadding: false,
    sortable: true,
    title: 'Time Zone',
  },
  {
    id: 'number',
    value: (props: InternalPhoneNumberAdminViewDto) =>
      phoneFormatter.stringToPretty(props.number),
    isNumeric: true,
    shouldDisablePadding: false,
    sortable: true,
    title: 'Number',
  },
  {
    id: 'isDefault',
    value: (props: InternalPhoneNumberAdminViewDto) => {
      return props.isDefault ? 'Yes' : 'No';
    },
    isNumeric: true,
    shouldDisablePadding: false,
    sortable: true,
    title: 'Default',
  },
  {
    id: 'isFeedbackNumber',
    value: (props: InternalPhoneNumberAdminViewDto) => {
      return props.isFeedbackNumber ? 'Yes' : 'No';
    },
    isNumeric: true,
    shouldDisablePadding: false,
    sortable: true,
    title: 'Feedback Number',
  },
  {
    id: 'supportUserIds',
    value: (props: InternalPhoneNumberAdminViewDto) => {
      const userNames = props.supportUserIds?.map(id => {
        const user = users.find(user => user.id === id);
        return user ? `${user.firstName} ${user.lastName} ` : null;
      });
      return userNames?.length > 1 ? userNames.join(', ') : userNames;
    },
    isNumeric: false,
    shouldDisablePadding: false,
    sortable: true,
    title: 'Support Users',
  },
];
